import OverviewGeneralRow from './general-row';
import { GeneralInfoTopTypes } from '../types';
import {
  formatDate,
  SelectType,
} from '../../../../../../baseella-ui-components/src';
import AddressesContent from './addresses-content';

import cn from '../styles.module.css';

const GeneralInfoCompanyTop = ({
  edit,
  control,
  errors,
  general,
  incorporationDates,
  countries,
  sicCodesDictionaries,
  productsCorporate,
  correspondenceAddressSameAsRegisteredAddress,
  businessAddressSameAsRegisteredAddress,
}: GeneralInfoTopTypes) => {
  let correspondenceContent;
  let businessContent;
  let registeredContent;

  if (!edit) {
    registeredContent = (
      <OverviewGeneralRow
        title="Registration address"
        description={general?.registrationAddress}
        control={control}
        edit={edit}
        type="text"
      />
    );
  } else {
    registeredContent = (
      <AddressesContent
        control={control}
        edit={edit}
        countries={countries}
        errors={errors}
        title="Registration"
        name="registered"
      />
    );
  }

  if (!edit) {
    correspondenceContent = (
      <OverviewGeneralRow
        title="Correspondent address"
        description={general?.correspondentAddress || '-'}
        control={control}
      />
    );
  } else {
    correspondenceContent = (
      <>
        <OverviewGeneralRow
          title="Correspondent address"
          control={control}
          edit={edit}
          name="correspondenceAddressSameAsRegisteredAddress"
          checkboxTitle="Coincides with the registered address"
          type="checkbox"
        />
        {!correspondenceAddressSameAsRegisteredAddress && (
          <AddressesContent
            control={control}
            edit={edit}
            countries={countries}
            errors={errors}
            title="Correspondent"
            name="correspondence"
          />
        )}
      </>
    );
  }

  if (!edit) {
    businessContent = (
      <OverviewGeneralRow
        title="Business address"
        description={general?.businessAddress || '-'}
        control={control}
      />
    );
  } else {
    businessContent = (
      <>
        <OverviewGeneralRow
          title="Business address"
          control={control}
          edit={edit}
          name="businessAddressSameAsRegisteredAddress"
          checkboxTitle="Coincides with the registered address"
          type="checkbox"
        />
        {!businessAddressSameAsRegisteredAddress && (
          <AddressesContent
            control={control}
            edit={edit}
            countries={countries}
            errors={errors}
            title="Business"
            name="business"
          />
        )}
      </>
    );
  }

  return (
    <div className={cn.generalTop}>
      <div className={cn.generalTopLeft}>
        {edit && (
          <OverviewGeneralRow
            title="Company Name"
            control={control}
            edit={edit}
            name="companyName"
            type="text"
            error={errors?.companyName?.message}
          />
        )}
        <OverviewGeneralRow
          title="Registered number"
          description={general?.companyNumber?.toUpperCase()}
          edit={edit}
          control={control}
          name="companyNumber"
          type="text"
          error={errors?.companyNumber?.message}
        />
        <OverviewGeneralRow
          title="Incorporated on"
          description={
            incorporationDates?.find(
              (item) => item.value === general?.dateOfIncorporation,
            )?.name || formatDate(general?.dateOfIncorporation as string)
          }
          control={control}
          edit={edit}
          name="dateOfIncorporation"
          type="date"
          error={errors?.dateOfIncorporation?.message}
        />
        <OverviewGeneralRow
          title="Country of incorporation"
          description={
            countries?.find(
              (item) => item.value === general?.countryOfIncorporationId,
            )?.name
          }
          control={control}
          edit={edit}
          name="countryOfIncorporationId"
          type="autocomplete"
          list={countries}
          error={errors?.countryOfIncorporationId?.message}
        />
        <OverviewGeneralRow
          title="Merchant ID"
          description={general?.merchantId || '-'}
          edit={edit}
          control={control}
          name="merchantId"
          type="text"
          error={errors?.merchantId?.message}
        />
        <OverviewGeneralRow
          title="SIC code"
          description={general?.sicCodes.join(',')}
          control={control}
          edit={edit}
          name="sicCodes"
          type="autocomplete-multiple"
          list={sicCodesDictionaries?.map((item) => ({
            ...item,
            value: item.name,
          }))}
          error={errors?.sicCodes?.message}
          zIndex={6}
        />
        <OverviewGeneralRow
          title="Products"
          control={control}
          type="select"
          name="productIds"
          edit={edit}
          selectType={SelectType.MULTIPLE}
          defaultValue={productsCorporate
            ?.filter((item) => {
              let result;

              if (
                general?.productIds?.find((product) => product === item.value)
              ) {
                result = item;
              }

              return result;
            })
            .map((item) => item.name)
            .join(', ')}
          list={productsCorporate}
          error={errors?.productIds?.message}
          zIndex={5}
        />
        {edit && correspondenceContent}
      </div>
      <div className={cn.generalTopRight}>
        {!edit && (
          <OverviewGeneralRow
            title="Status"
            description={general?.status}
            control={control}
          />
        )}
        {!edit && correspondenceContent}
        {registeredContent}
        {businessContent}
        <OverviewGeneralRow
          title="Site"
          edit={edit}
          control={control}
          type="text"
          name="websiteLink"
          error={errors?.websiteLink?.message}
        >
          <a
            href={`${
              general?.websiteLink?.includes('http') ||
              general?.websiteLink?.includes('https')
                ? ''
                : 'https://'
            }${general?.websiteLink}`}
            target="_blank"
            rel="noopener noreferrer"
            className={cn.generalSite}
          >
            {general?.websiteLink}
          </a>
        </OverviewGeneralRow>
        <OverviewGeneralRow
          title="VAT Number"
          edit={edit}
          control={control}
          description={general?.vatNumber || '-'}
          type="text"
          name="vatNumber"
          error={errors?.vatNumber?.message}
        />
      </div>
    </div>
  );
};

export default GeneralInfoCompanyTop;
